"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VerifyEmail = undefined;

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require("react-redux");

var _reactRouterRedux = require("react-router-redux");

var _reactHelmet = require("react-helmet");

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _auth = require("../../redux/modules/auth");

var _Spinner = require("../../components/Spinner");

var _Spinner2 = _interopRequireDefault(_Spinner);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var VerifyEmail = exports.VerifyEmail = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(VerifyEmail, _Component);

  function VerifyEmail() {
    (0, _classCallCheck3.default)(this, VerifyEmail);
    return (0, _possibleConstructorReturn3.default)(this, (VerifyEmail.__proto__ || (0, _getPrototypeOf2.default)(VerifyEmail)).apply(this, arguments));
  }

  (0, _createClass3.default)(VerifyEmail, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _props = this.props,
          verifyEmail = _props.verifyEmail,
          verifyToken = _props.routeParams.verifyToken;

      if (verifyToken) {
        verifyEmail(verifyToken);
      }
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var _props2 = this.props,
          pushRoute = _props2.pushRoute,
          verifyEmailSuccess = _props2.auth.verifyEmailSuccess;

      if (!verifyEmailSuccess && nextProps.auth.verifyEmailSuccess) {
        pushRoute("/kirjaudu");
      }
    }
  }, {
    key: "render",
    value: function render() {
      return _react2.default.createElement(
        "div",
        { className: "container" },
        _react2.default.createElement(_reactHelmet2.default, { title: "Vahvistetaan s\xE4hk\xF6postiosoitetta..." }),
        _react2.default.createElement(
          "div",
          { className: "row" },
          _react2.default.createElement(
            "div",
            { className: "col col-xs-12" },
            this.defineContent()
          )
        )
      );
    }
  }, {
    key: "defineContent",
    value: function defineContent() {
      if (this.props.auth.verifyEmailError) {
        return _react2.default.createElement(
          "p",
          { className: "error-message" },
          "S\xE4hk\xF6postin vahvistus ep\xE4onnistui."
        );
      }

      return _react2.default.createElement(
        "div",
        null,
        _react2.default.createElement(_Spinner2.default, { additionalClasses: "mp-spinner-inline" }),
        _react2.default.createElement(
          "span",
          { className: "wait-text-js" },
          "Vahvistetaan s\xE4hk\xF6postiosoitetta.."
        )
      );
    }
  }]);
  return VerifyEmail;
}(_react.Component), _class.propTypes = {
  auth: _react.PropTypes.object.isRequired,
  verifyEmail: _react.PropTypes.func.isRequired,
  pushRoute: _react.PropTypes.func.isRequired,
  routeParams: _react.PropTypes.object.isRequired
}, _temp);
exports.default = (0, _reactRedux.connect)(function (state) {
  return {
    auth: state.auth
  };
}, {
  verifyEmail: _auth.verifyEmail,
  pushRoute: _reactRouterRedux.push
})(VerifyEmail);


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/VerifyEmail/VerifyEmail.js
 ** module id = 1249
 ** module chunks = 0
 **/